export class InscricaoCatequese {

    public turmaId?: string;

    // Dados da Mãe
    public nomeMae?: string;
    public cpfMae?: string;
    public telefoneMae?: string;
    public emailMae?: string;
  
    // Dados do Pai (opcional)
    public nomePai?: string;
    public cpfPai?: string;
    public telefonePai?: string;
    public emailPai?: string;
  
    // Endereço
    public cep?: string;
    public endereco?: string;
    public bairro?: string;
    public complemento?: string;
    public municipio?: string;
    public municipioIbge?: string;
  
    // Catequizando
    public nomeCatequizando?: string;
    public cpfCatequizando?: string;
    public dataNascimento?: string; // ou Date, conforme uso no sistema
    public sexo?: string;
    public celularCatequizando?: string;
    public emailCatequizando?: string;
    public estadoCivil?: string;
    public escolaridade?: string;
    public batizado?: boolean;
    public igrejaBatismo?: 'catolica' | 'nao_catolica';
    public nomeIgrejaBatismo?: string;
    public matrimonio?: boolean;
    public situacaoMatrimonio?: string;
    public primeiraComunhao?: boolean;
    public possuiNecessidadeEspecial?: boolean;
    

    public alergico?: boolean;
    public diabetico?: boolean;
    public intoleranteLactose?: boolean;
    public tdah?: boolean;
    public autista?: boolean;
    public dislexo?: boolean;
    public tod?: boolean;
    public outros?: boolean;
    public necessidadeEspecialTxt?: string;   

    public catequizandoSemCpf?: boolean;

    public maeSemCpf?: boolean;
    public paiSemCpf?: boolean;
    public naoConstaPai?: boolean;

    public cpfCatequizandoConsultado?: boolean;
    public cpfPaiConsultado?: boolean;
    public cpfMaeConsultado?: boolean;
  
    // Foto
    public foto?: string;
  
    constructor(data?: Partial<InscricaoCatequese>) {
      if (data) {
        Object.assign(this, data);
      }
    }
  }
  